<template>
  <div class="componentSty">
    <m-title></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">日志时间段</span>
        <!-- <el-date-picker
          @change="dataChange($event, ['starttime', 'endtime'])"
          v-model="dataval"
          type="datetimerange"
          range-separator="至"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @focus="selectData"
          :default-time="['00:00:00', '00:00:00']"
        >
        </el-date-picker> -->
        <el-date-picker
            v-model="conditions.starttime"
            type="datetime"
            style="width: 180px;"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间">
          </el-date-picker>
            至
            <el-date-picker
            v-model="conditions.endtime"
            type="datetime"
            style="width: 180px;"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间">
          </el-date-picker>
        <span class="fonints">操作人</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.username"
          clearable
        >
        </el-input>
        <span class="fonints">参数</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.params"
          clearable
        >
        </el-input>
      </div>
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
        
        <span class="fonints">操作</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.operation"
          clearable
        >
        </el-input>
      </div>
        <div class="componentSty_content_title_flex_button">
          <button class="buttons" @click="selectlist">查询</button>
        </div>
      </div>
      
      <div class="componentSty_content_table" style="border:none;top: 90px;">
        <el-table
          :data="arrlist.list"
          style="width: 100%; height: 80%"
          @sort-change="sortchange"
           height="80%"
            border
        >
          <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" sortable="custom" label="创建时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.createDate, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="ip" label="ip地址"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="username" label="操作人"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="params" label="参数"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="operation" label="操作"> </el-table-column>
		  <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="result" label="返回值"> </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list && arrlist.list.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.totalCount"
            @current-change="getlist"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
export default {
  data() {
    return {
      conditions: {
        page: 1,
        limit: 20,
        username: "", //操作人
        starttime: "", //开始时间
        endtime: "", //结束时间
        params: "",
        operation: "",
      },
      dataval: [],
      defaultTime: ["00:00:00", "00:00:00"],
      arrlist: [],
    };
  },
  components: {
    mTitle,
  },
  created() {
    this.getlist();
  },
  methods: {
    async getlist(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/sys/log/logList",
        "get",
        this.conditions
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data.page;
    },
    selectData() {
      let time = new Date(),
        HH = (time.getHours() -1+ "").padStart(2, 0),
        HH2 = (time.getHours() + "").padStart(2, 0),
        mm = (time.getMinutes() + "").padStart(2, 0),
        ss = (time.getSeconds() + "").padStart(2, 0);
      this.defaultTime = [`${HH}:${mm}:${ss}`, `${HH2}:${mm}:${ss}`];
    },
    // dataChange(event, prop) {
    //   this.conditions[prop[0]] = event&&new Date(event[0])||null;
    //   this.conditions[prop[1]] = event&&new Date(event[1])||null;
    // },
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getlist();
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getlist();
      });
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>